/** Table-scoped hold windows (maintenance, holds) — separate from venue service hours. */
import moment from "moment-timezone";
import { FORMATS } from "../core/formats";
function intervalsOverlap(a, b) {
    return a.start < b.end && b.start < a.end;
}
export function blockToIntervalMs(block, tz) {
    if (!block.date || !block.start || !block.end)
        return null;
    const start = moment.tz(`${block.date} ${block.start}`, FORMATS.moment.datetime, tz);
    let end = moment.tz(`${block.date} ${block.end}`, FORMATS.moment.datetime, tz);
    if (!start.isValid() || !end.isValid())
        return null;
    if (end.isSameOrBefore(start)) {
        end = end.clone().add(1, "day");
    }
    return { start: start.valueOf(), end: end.valueOf() };
}
export function buildBlockedByTableFromBlocks(blocks, tz) {
    const map = new Map();
    for (const block of blocks) {
        const iv = blockToIntervalMs(block, tz);
        if (!iv)
            continue;
        for (const tid of block.table_ids || []) {
            if (!tid)
                continue;
            if (!map.has(tid))
                map.set(tid, []);
            map.get(tid).push(iv);
        }
    }
    return map;
}
export function mergeOccupiedByTableMaps(...maps) {
    const out = new Map();
    for (const map of maps) {
        for (const [tid, list] of map) {
            if (!out.has(tid))
                out.set(tid, []);
            out.get(tid).push(...list);
        }
    }
    return out;
}
export function tableBlockedForWindow(tableId, window, blocked) {
    const list = blocked.get(tableId);
    if (!list?.length)
        return false;
    return list.some((iv) => intervalsOverlap(iv, window));
}
export function filterTableBlocksForDay(blocks, dayDateStr) {
    if (!blocks?.length)
        return [];
    return blocks.filter((b) => b.date === dayDateStr);
}
//# sourceMappingURL=table_blocks.js.map